import { reactive, readonly } from 'vue'

export interface ToastItem {
  id: number
  message: string
  duration: number
}

interface ToastState {
  items: ToastItem[]
}

const state = reactive<ToastState>({ items: [] })

let nextId = 1

export function pushToast(message: string, duration = 2200): number {
  const id = nextId++
  state.items.push({ id, message, duration })
  return id
}

export function dismissToast(id: number): void {
  const idx = state.items.findIndex((i) => i.id === id)
  if (idx >= 0) state.items.splice(idx, 1)
}

export function clearToasts(): void {
  state.items.splice(0, state.items.length)
}

export function useToast(): {
  toast: (message: string, duration?: number) => number
  items: ReadonlyArray<ToastItem>
} {
  return {
    toast: pushToast,
    items: readonly(state.items) as ReadonlyArray<ToastItem>,
  }
}
